import axios from 'axios';

const apiProd = axios.create({
    baseURL: 'https://api.prod.aprincipalbb.com.br/'
});

export default apiProd;